import { render, staticRenderFns } from "./ProductAssociatedCategories.vue?vue&type=template&id=186cfbf4&"
import script from "./ProductAssociatedCategories.vue?vue&type=script&lang=ts&"
export * from "./ProductAssociatedCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports